var map = {
	"./": 7672,
	"./App": 3465,
	"./App.css": 3508,
	"./App.test": 3517,
	"./App.test.tsx": 3517,
	"./App.tsx": 3465,
	"./Images/ProjectImages/again.png": 2494,
	"./Images/ProjectImages/bossSlayers.png": 7694,
	"./Images/ProjectImages/eg_ajour_logo.svg": 5448,
	"./Images/ProjectImages/escape.png": 3670,
	"./Images/ProjectImages/introShop.png": 467,
	"./Images/ProjectImages/price-bot.png": 1202,
	"./Images/ProjectImages/school.png": 1596,
	"./Images/ProjectImages/silkroutegame.png": 1821,
	"./Images/Show.png": 3875,
	"./Images/ShowSecond.png": 7718,
	"./Images/Welcome.png": 6473,
	"./Images/icons8-document-64.png": 9360,
	"./ShowProject": 5425,
	"./ShowProject.css": 4378,
	"./ShowProject.tsx": 5425,
	"./index": 7672,
	"./index.css": 1174,
	"./index.tsx": 7672,
	"./logo.svg": 1100,
	"./pdfs/CV-Sebastian-Juul-Knudsen-English.pdf": 2796,
	"./projectInfo/projectInfo": 3067,
	"./projectInfo/projectInfo.json": 3067,
	"./react-app-env.d": 4398,
	"./react-app-env.d.ts": 4398,
	"./reportWebVitals": 8983,
	"./reportWebVitals.ts": 8983,
	"./setupTests": 2887,
	"./setupTests.ts": 2887,
	"./types": 4976,
	"./types.tsx": 4976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;